<template>
  <div class="row">
    <div class="col-md-5 col-sm-12">
      <Title :page="page" />
    </div>
    <div class="col-md-12 col-sm-12">
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <BreadCrumb :page="page" />
        </div>
        <div class="col-md-6 col-sm-12 h-0 mt-4 text-right ">
          <div class="row btn-group">
            <div class="col-md-12 col-sm-12 mx-0 mt-4">
              <ActionButton
                variant="outline-success mr-2"
                i="fas fa-arrow-circle-left"
                text="Regresar"
                @click="() => $router.push('/student')"
              />
              <ActionButton
                v-if="canGoToEvaluationDiscussion"
                variant="outline-success mr-2"
                i="fas fa-file-alt"
                @click="goToEvaluationDiscussion"
              >
                Discusión de Evaluaciones
              </ActionButton>
              <ActionButton
                v-if="canRequestAdditionalEvaluation"
                class="mr-2"
                variant="success"
                type="button"
                i="fas fa-file-plus"
                @click="goToAddEditEvaluation"
              >
                Añadir
              </ActionButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Separator -->
    <div class="col-md-12 col-sm-12 dropdown-divider pb-4 w-100" />

    <!-- Informacion de la Determinacion -->
    <div class="col-12 px-4">
      <div class="row search-panel rounded">
        <div class="col-md-3">
          <CustomDropDown
            v-model="selectedAcademicYear"
            class="w-100"
            placeholder="Seleccione el año"
            fieldkey="id"
            fieldname="description"
            :options="academicYears"
          />
        </div>
        <div class="col-md-7">
          <CustomDropDown
            v-model="selectedEvaluationType"
            placeholder="Seleccione Servicio"
            fieldkey="evaluationTypeId"
            fieldname="description"
            :options="evaluationsType"
          />
        </div>
        <div class="col-md-2 text-right">
          <ActionButton type="submit" variant="success px-5" @click="search">
            Buscar
          </ActionButton>
        </div>
      </div>
    </div>

    <div class="col-12 my-4">
      <custom-separator text="Resultado de Referidos a Evaluación" />
    </div>

    <div class="col-12">
      <ReferralEvaluationItem
        :items="evaluations"
        @on-delete="onDeleteHandler"
        @on-enter="onEnterPendingSignatureReferral"
        @on-download-referral-report="onOnDownloadReferralReport($event)"
      />
    </div>
  </div>
</template>

<script>
import Title from "@/components/common/page/Title";
import BreadCrumb from "@/components/common/page/BreadCrumb";

import ActionButton from "@/components/common/ActionButton";

import loading from "@/mixin/loading.mixin";
import CustomDropDown from "@/components/common/CustomDropDown";

import ReferralEvaluationItem from "./components/ReferralEvaluationItem";
import StudentStatuses from "@/utils/constants/reg/studentStatuses.js";
import mixAlert from "@/mixin/alert.mixin";
import { CustomSeparator } from "@/components/common";
import ReportService from "@/services/report";
import store from "@/store/index";

export default {
  mixins: [loading, mixAlert],
  components: {
    Title,
    BreadCrumb,
    ActionButton,
    CustomDropDown,
    CustomSeparator,
    ReferralEvaluationItem
  },
  data() {
    return {
      page: {
        icon: "fas fa-user-circle",
        title: "Solicitud de Evaluación Adicional",
        routes: ["Inicio", "Estudiante", "Solicitud de Evaluación Adicional"]
      },
      academicYears: [],
      evaluationsType: [],
      selectedAcademicYear: null,
      selectedEvaluationType: null,
      evaluations: [],
      hasSignedPei: false
    };
  },
  mounted() {
    this.fetchData();
    if (this.studentStatus == StudentStatuses.Elegible) {
      this.hasSignedPei = this.getSignedPei();
    }
  },
  methods: {
    goToEvaluationDiscussion() {
      let path = `/student/evaluationdiscuss/${this.studentSieId}`;
      this.$router.push(path);
    },
    goToAddEditEvaluation() {
      if (!this.isStudenElegible) {
        this.ShowToast(
          "Aviso",
          `Es posible añadir solicitudes para evaluación solo a estudiantes en estatus Servido o Elegible con PEI firmado. `,
          "error"
        );
        return;
      }

      if (
        this.studentStatus == StudentStatuses.Elegible &&
        !this.hasSignedPei
      ) {
        this.ShowToast(
          "Aviso",
          `Es posible añadir solicitudes para evaluación solo a estudiantes en estatus Servido o Elegible con PEI firmado. `,
          "error"
        );
        return;
      }
      this.$router.push("/student/AddEditEvaluations");
    },
    async fetchData() {
      this.fetchAcademicYear();
      this.fetchEvaluationsType();
    },
    async fetchAcademicYear() {
      await this.$ApiGet(
        "/api/academicyears/therapyStartYear?includeFuture=true"
      )
        .then(res => {
          res.data.unshift({
            id: null,
            description: "Todos",
            year: ""
          });
          this.academicYears = res.data ? res.data : [];
        })
        .catch(err => {
          this.response = err;
        });
    },
    async fetchEvaluationsType() {
      await this.$ApiGet(`/api/studentEvaluation/EvaluationTypes/${true}`)
        .then(res => {
          res.data.unshift({
            evaluationTypeId: null,
            description: "Todos",
            year: ""
          });

          this.evaluationsType = res.data ? res.data : [];
        })
        .catch(err => {
          this.response = err;
        });
    },
    async search() {
      await this.$ApiGet(
        "/api/studentevaluation/studentadditionalevaluations?studentSieId=" +
          this.studentSieId +
          (this.selectedAcademicYear && this.selectedAcademicYear.id
            ? "&academicYearId=" + this.selectedAcademicYear.id
            : "") +
          (this.selectedEvaluationType &&
          this.selectedEvaluationType.evaluationTypeId
            ? "&evaluationTypeId=" +
              this.selectedEvaluationType.evaluationTypeId
            : "")
      )
        .then(res => {
          this.evaluations = res.data ? res.data : [];
        })
        .catch(err => {
          this.response = err;
        });
    },
    async getSignedPei() {
      await this.$ApiGet(
        "/api/pei/hassignedpei?studentSieId=" + this.studentSieId
      )
        .then(res => {
          return res.data;
        })
        .catch(err => {
          this.response = err;
        });
    },
    async onDeleteHandler({ id }) {
      if (id) {
        let response = await this.ShowCancelModal(
          "Confirmación",
          "¿Esta seguro que desea eliminar el referido?",
          "Sí",
          "No"
        );

        if (response) {
          const { data } = await this.$ApiDelete(
            `/api/studentevaluation/deletestudentreferral/${id}`
          ).catch(err => {
            this.ShowToast("", err.message, "error");
          });
          if (data) {
            this.ShowToast(
              "Proceso Exitoso.",
              "El referido ha sido eliminado exitosamente.",
              "success"
            );
            await this.search();
          }
        }
      }
    },
    async onOnDownloadReferralReport(referralId) {
      await ReportService.downloadReferralReport(referralId);
    },
    onEnterPendingSignatureReferral(referral) {
      this.$router.push({
        name: "AddEditEvaluations",
        query: { studentReferralId: referral.id }
      });
    }
  },
  computed: {
    studentSieId() {
      return this.$store.getters.SelectedStudent.studentId;
    },
    isStudenElegible() {
      if (this.$store.getters.SelectedStudent != null) {
        let status = this.$store.getters.SelectedStudent.status;
        switch (status) {
          case StudentStatuses.Servido:
            return true;
          case StudentStatuses.Elegible:
            return true;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
    studentStatus() {
      return this.$store.getters.SelectedStudent.status;
    },
    userPilotPlan() {
      return this.$store.getters["$_user/pilotPlan"];
    },
    canRequestAdditionalEvaluation() {
      return store.getters.HasPermission(
        "student.additionalevaluations.addbutton"
      );
    },
    canGoToEvaluationDiscussion() {
      return store.getters.HasPermission(
        "student.additionalevaluations.evaluationdiscussionbutton"
      );
    }
  }
};
</script>

<style scope>
form {
  width: 100%;
}
</style>
<style src="@/assets/css/component/radio-button.css"></style>
<style src="@/assets/css/component/datepicker.css"></style>
<style src="@/assets/css/component/badge.css"></style>
<style src="@/assets/css/component/textarea.css"></style>
<style src="@/assets/css/component/messages.css"></style>

<style scoped>
.disabled-page {
  pointer-events: none;
}

.wrapper-block {
  cursor: not-allowed !important;
}
.global-thead-dark {
  background-color: #3f5b60 !important;
}
.buttoneval {
  border: 1px solid #2db782;
  color: #2db782;
}
.search-panel {
  background-color: #f4f6f3;
  padding: 20px;
}
</style>
